import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap"
import React, { useEffect, useState } from "react"
import {
  fetchData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Loader from "components/Loader/loader"
import { MdSave, MdEmail, MdDownload, MdClose } from "react-icons/md"
import Swal from "sweetalert2"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"

const ContractModal = ({ isOpen, toggle, location, fetchLocations }) => {
  const [loading, setLoading] = useState(false)

  const [contract, setContract] = useState("")
  const [templates, setTemplates] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState("")

  useEffect(() => {
    if (isOpen) {
      // reset modal state on every open
      setSelectedTemplate("")
      setContract(location?.contract)
      setTemplates([])

      getTemplates()
    }
  }, [isOpen, location])

  async function getTemplates() {
    const APIData = await fetchData(setLoading, "template")
    if (APIData?.data) {
      setTemplates(APIData.data.reverse())
    }
  }

  const handleTemplateSelect = async e => {
    const templateId = e.target.value
    setSelectedTemplate(templateId)

    const APIdata = await FetchPostData(
      setLoading,
      "location/fetch/contract/details",
      { locationId: location?.id, templateId }
    )

    if (APIdata?.data?.success) {
      setContract(APIdata?.data?.contractDetails)
    }
  }

  // 🔹 Action handlers (API later)
  const handleSave = async () => {
    const APIdata = await FetchPutData(
      setLoading,
      "location/save/contract/details",
      location?.id,
      {
        contract,
      }
    )

    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Success",
        text: "Contract Updated Successfully",
        icon: "success",
      })
      fetchLocations()
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleSendEmail = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to send Contract",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Send it!",
      cancelButtonText: "Cancel",
    })

    // ❌ User cancelled
    if (!result.isConfirmed) return
    const APIdata = await FetchPutData(
      setLoading,
      `location/send/contract/email`,
      location?.id,
      {
        contract,
      }
    )

    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Contract Send Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
    } else {
      Swal.fire({
        title: "Something Went Wrong.",
        text: APIdata?.response?.data?.message || "Unable to Send Contract",
        icon: "error",
      })
    }
  }

  const handleDownload = async () => {
    // Create a temporary div for the HTML content
    const div = document.createElement("div")
    div.innerHTML = contract
    div.style.width = "800px" // optional, for proper scaling
    div.style.padding = "20px"
    div.style.background = "white"
    document.body.appendChild(div)

    // Use html2canvas to convert HTML to canvas
    const canvas = await html2canvas(div, { scale: 2 })
    const imgData = canvas.toDataURL("image/png")
    const pdf = new jsPDF("p", "mm", "a4")
    const imgProps = pdf.getImageProperties(imgData)
    const pdfWidth = pdf.internal.pageSize.getWidth()
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight)
    pdf.save(`${location?.name || "contract"}.pdf`)

    // Remove temporary div
    document.body.removeChild(div)
  }

  return (
    <Modal isOpen={isOpen} fullscreen centered>
      {loading && <Loader />}

      <ModalHeader toggle={toggle}>{location?.name} Contract</ModalHeader>

      <ModalBody>
        <select
          className="form-select rounded-4 mb-3"
          value={selectedTemplate}
          onChange={handleTemplateSelect}
        >
          <option value="">Select Contract Template</option>
          {templates.map(item => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        <div className="big-editor">
          <CKEditor
            editor={ClassicEditor}
            data={contract}
            onChange={(event, editor) => {
              setContract(editor.getData())
            }}
          />
        </div>
      </ModalBody>

      <ModalFooter className="pt-0">
        <Button color="primary" onClick={handleSave}>
          <MdSave className="me-1" />
          Save
        </Button>

        <Button color="success" onClick={handleSendEmail}>
          <MdEmail className="me-1" />
          Send Email
        </Button>
        <Button color="info" onClick={handleDownload}>
          <MdDownload className="me-1" />
          Download
        </Button>
        <Button color="secondary" onClick={toggle}>
          <MdClose className="me-1" />
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ContractModal
